import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 28 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 18\" id=\"icon-up\"><defs><style>#icon-up .cls-1{fill:#99989a;}</style></defs><polygon class=\"cls-1\" points=\"13.94 0 0.11 18 27.76 18 13.94 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol